import React from 'react';
import { Brain } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const marineBlue = '#1e5f74'; // Dark marine blue color
  const marineBlueDark = '#164a5a'; // Even darker for hover states
  const lightBlue = '#5fb3d4';
  return (
    <footer className="bg-white py-12 px-4">
      <div className="max-w-7xl mx-auto px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo and Description */}
          <div className="col-span-1">
            <div className="flex items-center space-x-2 mb-4">
              <Brain className="h-8 w-8" style={{color: lightBlue}} />
                       <span className="text-2xl font-bold">
                         <span style={{color: lightBlue}}>ADHD</span>
                         <span style={{color: marineBlue}}>RapidCare</span>
              </span>
            </div>
            <p className="text-gray-600 text-sm mb-4">
              The future of ADHD care - rapid <br /> diagnosis, weekly AI monitoring,<br /> and 
continuous support by <br /> qualified professionals.
            </p>
          <div className="space-y-2 mt-8 md:mt-12 lg:mt-14">
   <h3 className="font-semibold text-gray-800 mb-2">Contact</h3>
   <a
     href="mailto:admin@adhdrapidcare.com"
     className="text-gray-600 text-sm hover:text-[#1e5f74] block"
   >
     admin@adhdrapidcare.com
   </a>
 </div>
          </div>

          {/* Services */}
          <div className="col-span-1">
            <h3 className="font-semibold text-gray-800 mb-4">Services</h3>
            <ul className="space-y-4">
              <li>
                <div className="text-gray-600 text-sm">
                  ADHD Assessment
                </div>
              </li>
              <li>
                <div className="text-gray-600 text-sm">
                  Psychiatric Consultation
                </div>
              </li>
              <li>
                <div className="text-gray-600 text-sm">
                  Treatment Planning
                </div>
              </li>
              <li>
                <div className="text-gray-600 text-sm">
                  Ongoing Monitoring
                </div>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div className="col-span-1">
            <h3 className="font-semibold text-gray-800 mb-4">Company</h3>
            <ul className="space-y-4">
              <li>
                <Link to="/about-us" className="text-gray-600 hover:text-blue-700 text-sm block">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/legal" className="text-gray-600 hover:text-blue-700 text-sm block">
                  Legal
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="text-gray-600 hover:text-blue-700 text-sm block">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms-of-service" className="text-gray-600 hover:text-blue-700 text-sm block">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>

          {/* Information */}
          <div className="col-span-1">
            <h3 className="font-semibold text-gray-800 mb-4">Information</h3>
            <ul className="space-y-4">
              <li>
                <Link to="/about-adhd" className="text-gray-600 hover:text-blue-700 text-sm block">
                  About ADHD
                </Link>
              </li>
              <li>
                <Link to="/care-plan" className="text-gray-600 hover:text-blue-700 text-sm block">
                  Care Plan
                </Link>
              </li>
              <li>
                <Link to="/medications" className="text-gray-600 hover:text-blue-700 text-sm block">
                  Medications
                </Link>
              </li>
              <li>
                <Link to="/care-plan#insurance-rebates" className="text-gray-600 hover:text-blue-700 text-sm block">
                  Medicare & Insurance Rebates
                </Link>
              </li>

              <li>
                <Link to="/nurses" className="text-gray-600 hover:text-blue-700 text-sm block">
                  Nurses
                </Link>
              </li>

            </ul>
          </div>
        </div>


        <div className="whitespace-nowrap w-fit">
          <p className="w-fit text-gray-600 text-xs leading-relaxed mt-8">
            We do not provide medical advice, and we are not a substitute for professional medical advice, 
            diagnosis or treatment.<span className="font-semibold" > If you have a medical emergency, immediately call your doctor or dial 000.</span>
          </p>
        </div>
              
      {/* Three Column Info Section */}

      <div className="border-t border-gray-200 mt-6">
        <div className="relative grid grid-cols-3  py-4"> {/* was py-6 */}
          
          {/* vertical dividers */}
          <div className="absolute top-12 bottom-12 left-1/3 w-px bg-gray-200 pointer-events-none"></div> {/* was top-12 bottom-12 */}
          <div className="absolute top-12 bottom-12 left-2/3 w-px bg-gray-200 pointer-events-none"></div> {/* was top-12 bottom-12 */}
          
          {/* HIPAA Compliant Services */}
          <div className="px-2 text-left">
            <h4 className="text-sm font-semibold text-gray-800 mb-2 mt-2">HIPAA Compliant</h4>
            <p className="text-gray-600 text-xs leading-relaxed">
              Your health information is protected <br />under HIPAA regulations
            </p>
          </div>

          {/* Licensed Professionals */}
          <div className="pl-24 text-left">
            <h5 className="font-semibold text-sm text-gray-800 mb-2 mt-2">Licensed Professionals</h5>
            <p className="text-gray-600 text-xs leading-relaxed">
              All care provided by licensed nurses <br />and healthcare professionals
            </p>
          </div>

          {/* Emergency */}
          <div className="pl-24 text-left">
            <h4 className="font-semibold text-sm text-gray-800 mb-2 mt-2">Emergency Services</h4>
            <p className="text-gray-600 text-xs mb-2">Emergency 000</p>
            <p className="text-gray-600 text-xs mb-2">Lifeline call 13 11 14</p>
            <p className="text-gray-600 text-xs mb-2">Lifeline text 0477 13 11 14</p>
          </div>

        </div>
      </div>






        {/* Copyright */}
        <div className=" pt-8 border-t border-gray-200  mb-4">
          <p className="text-center text-gray-600 text-sm">
            © {new Date().getFullYear()} ADHDRapidCare. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
